import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { Permission } from '../models/permission.enum';

export const qualityAuditsGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.hasPermission(Permission.CanAccessQualityAudit)) {
    router.navigate(['/access-denied']);
    return false;
  }

  return true;
};

